import { SignInPage as CoreSignInPage } from '@backstage/core-components';
import type { IdentityProviders } from '@backstage/core-components';
import {
  configApiRef,
  githubAuthApiRef,
  useApi,
} from '@backstage/core-plugin-api';
import type { SignInPageProps } from '@backstage/plugin-app-react';

// Who a refused person asks, and where to get the id that person will need. Both halves
// are required (FR-011, SC-010) — a line with only the contact still costs a round trip.
export const ACCESS_CONTACT =
  'Not on the roster? Ask @BlindBat (Kuanysh Bekkulov) for access, and send your GitHub ' +
  'node id — open https://api.github.com/users/YOUR-USERNAME and copy "node_id" ' +
  '(the long one, not "id").';

// The guidance rides on the provider card rather than a sibling under the button: the
// card's message renders directly above its action button, while `SignInPage` is a
// `Page` at height 100vh, so anything appended after it sits below the fold unread.
const githubProvider = {
  id: 'github-auth-provider',
  title: 'GitHub',
  message: `Sign in with your GitHub account. ${ACCESS_CONTACT}`,
  apiRef: githubAuthApiRef,
};

export const SignInPage = (props: SignInPageProps) => {
  const configApi = useApi(configApiRef);
  // An absent key must read as "not production", not throw: App.test.tsx renders the app
  // with a stub config that has no `auth` key at all (R11).
  const isProduction =
    configApi.getOptionalString('auth.environment') === 'production';

  const providers: IdentityProviders = isProduction
    ? [githubProvider]
    : [githubProvider, 'guest'];

  return <CoreSignInPage {...props} providers={providers} />;
};
